import { SEND_SELF_ASSESSMENT_LINK } from './constants';
import fetchWithRefresh from './fetchWithRefresh';

export interface Res {
    success: string;
    error?: {
        code: string;
        type: string;
    };
}

export default (aid: string): Promise<Res> => {
    return fetchWithRefresh(SEND_SELF_ASSESSMENT_LINK(aid), {
        method: 'PUT',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            message_id: 'DR_SA',
        }),
    }).then((res) => {
        return res.json();
    });
};
